<template>
  <div class="md:flex md:justify-around mb-8">
    <RadioSelector
      v-for="option in options" :key="option.name" :option="option"
      class="sm:mb-8"
      ref="radioSelectors"
      @click="selectOption(option)">
    </RadioSelector>
  </div>
</template>

<script>
import RadioSelector from '@/components/RadioSelector'

export default {
  name: 'RadioGroup',
  props: ['options'],
  components: { RadioSelector },
  methods: {
    getSelectedOption () {
      return this.options.find(option => option.selected)
    },
    selectOption (selectedOption) {
      this.options.forEach(option => {
        option.selected = false
      })

      selectedOption.selected = true

      this.$refs.radioSelectors.forEach(selector => {
        selector.setSelect(selector.name === selectedOption.name)
      })
    },
    isValid () {
      return this.options.filter(option => option.selected).length === 1
    },
    reset () {
      this.$refs.radioSelectors.forEach(selector => selector.reset())
    }
  }
}
</script>
